import React from 'react';

import DatePicker from 'react-datepicker';
import moment from 'moment';

import 'react-datepicker/dist/react-datepicker.css';
// import './registration/calendar.css'


const renderDatePicker = ({className, label, input, placeholder, defaultValue, meta: {touched, error} }) => {
	if (touched && error) {
		return (
			<div className={className}>
				<div className="input-field">
					<label className="is-invalid-label">
		        <DatePicker 
		        className="is-invalid-input"
		        {...input}
		        value={null}
		        dateFormat="YYYY-MM-DD" 
						withPortal
						peekNextMonth
						showMonthDropdown
						showYearDropdown
						dropdownMode="select"
						maxDate={moment()}
						placeholderText="Birthdate"
		        selected={input.value ? moment(input.value, 'YYYY-MM-DD') : null} 
		        />
		        <span className="form-error is-visible" id="uuid">{error}</span>
		      </label>
		    </div>
		  </div>
		)
	} else {
		return (
		<div className={className}>	
		<div className="input-field">
				<DatePicker 
		      {...input}
		      value={null}
		      dateFormat="YYYY-MM-DD" 
					withPortal
					peekNextMonth
					showMonthDropdown
					showYearDropdown
					dropdownMode="select"
					maxDate={moment()}
					placeholderText="Birthdate"
		      selected={input.value ? moment(input.value, 'YYYY-MM-DD') : null} 
		      />
    </div>
    </div>
    )
	}


}

export default renderDatePicker


// WEBPACK FOOTER //
// ./src/components/Datepicker.js